import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateHtml',
  standalone: true
})
export class TruncateHtmlPipe implements PipeTransform {
  transform(value: string, limit: number = 50): string {
    if (!value) return '';

    // Strip tags the same way on both SSR and browser so hydration sees
    // identical text nodes. Using a regex strip avoids the document.createElement
    // call that would throw on the server and produce different entity-decoded
    // text compared to the server's regex fallback.
    const text = value
      .replace(/<[^>]*>/g, '')            // strip all HTML tags
      .replace(/&amp;/g, '&')             // decode common entities
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, ' ')
      .trim();

    return text.length > limit ? text.slice(0, limit) + '...' : text;
  }
}
